import React from 'react';
import { NavLink, useParams } from 'react-router-dom';

import ServerPageProvider from '@common/react/components/Core/ServerPageProvider/ServerPageProvider';

import Background from '@app/components/UI/Background/Background';
import { HelmetTags } from '@app/components/UI/Helmet/HelmetCustom';
import ShareLinks from '@app/components/UI/ShareLinks/ShareLinks';
import Subscribe from '@app/components/UI/Subscribe/Subscribe';
import { BlogPost } from '@app/objects/Education';
import '@app/scss/pages/EducationPost.scss';

interface PostProps {
	post: BlogPost;
}

const Post: React.FC<PostProps> = ({ post }) => {
	const params = useParams<{ category: string }>();

	return (
		<div className="pages is-relative">
			<Background />
			<div className="education-post">
				<div className="container-post">
					<div className="firs-section">{post.title && <h1 className="h2 text-center">{post.title}</h1>}</div>
				</div>
				<div className="bg-white-opacity h4 info-post">
					<div className="container-post">
						{post.avatar && <img className="avatar" src={post.avatar} alt="dogs" />}
						{post.text && <div className="text" dangerouslySetInnerHTML={{ __html: post.text }} />}
						<div className="last-block text-primary">
							{post.topics.length ? (
								<div className="tags">
									{post.topics.map((topic) => (
										<NavLink key={topic.id} to={`/education/${params.category}?topic=${topic.topic.name}`} className="tag">
											{topic.topic.name}
										</NavLink>
									))}
								</div>
							) : null}
							<div className="media">
								<span>Share:</span>
								<ShareLinks />
							</div>
						</div>
					</div>
				</div>
				<div className="subscribe">
					<div className="container-post">
						<div className="form text-center">
							<h2>Subscribe to learn a new posts</h2>
							<p className="h4">
								Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna
								aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.
							</p>
							<Subscribe type={0} buttonText="Subscribe" />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const EducationPost = () => {
	return (
		<ServerPageProvider
			path="education"
			inner={(page) => {
				return (
					<>
						<HelmetTags lang={page.langs[0]} title={page.item.title} />
						<Post post={page.item} />
					</>
				);
			}}
		/>
	);
};

export default EducationPost;
